import { BaseComponent2 } from '../../_common/client/base-component2';

export class OffersCashbackComponent extends BaseComponent2 {
    public readonly rootSelector = '.js_of_offers-cashback';

    public async onReloadComponentEvent(): Promise<void> {
        return;
    }
}
